import axios from 'axios';

// Ensure we target the right API endpoint (proxied in Vite)
const API_URL = '/api/swipeticker';

export const swipeTickerService = {
    // Identity
    getOrCreateIdentity: async (googleToken = null) => {
        try {
            const res = await axios.post(`${API_URL}/identity`, { google_token: googleToken });
            return res.data;
        } catch (error) {
            console.error("Identity Error:", error);
            // Fallback for development if API fails? Or let generic error handler catch it.
            throw error;
        }
    },

    // Deck (Fetch today's deck)
    getDailyDeck: async () => {
        try {
            // New endpoint needed! 
            // Wait, we didn't implement GET /deck in backend yet?
            // Checking router implementation... 
            // Ah, we implemented generate_deck script but not the GET endpoint in router!
            // I need to add GET /deck to router first. 
            const res = await axios.get(`${API_URL}/deck`);
            return res.data;
        } catch (error) {
            console.error("Deck Fetch Error:", error);
            return [];
        }
    },

    // Swipe Action
    recordSwipe: async (userId, ticker, action, price) => {
        try {
            await axios.post(`${API_URL}/swipe`, {
                user_id: userId,
                ticker,
                action, // PASS, BUY_LIST, SHORTLIST
                price: parseFloat(price)
            });
        } catch (error) {
            console.error("Swipe Record Error:", error);
        }
    },

    // Stats
    getStats: async (userId) => {
        try {
            const res = await axios.get(`${API_URL}/stats/${userId}`);
            return res.data;
        } catch (error) {
            console.error("Stats Error:", error);
            return null;
        }
    }
};
